import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import { auth } from '../firebase'
import store from '../store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue'),
    props: {api:'/api/books'}
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import( /* webpackChunkName: "login" */ '../views/Signup.vue')
  },
  {
    path: '/complete_profile',
    name: 'Complete-Profile',
    component: () => import( /* webpackChunkName: "login" */ '../views/Complete-Profile.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import( /* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sites',
    name: 'sites',
    component: () => import( /* webpackChunkName: "settings" */ '../views/Sites.vue'),
    beforeEnter: (to, from, next) => {
      const userRole = store.state.userRole.role
  
      if (userRole != 1){
        next('/')
      }else{
        next()
      }
  
    },
    meta: {
      requiresAuth: true,
      adminRole: true
    }
  },
  
  {
    path: '/InductionDashboard',
    name: 'InductionDashboard',
    component: () => import( /* webpackChunkName: "InductionDashboard" */ '../views/InductionDashboard.vue'),
    props: {api:'/api/books'},
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/InductionControl',
    name: 'InductionControl',
    component: () => import( /* webpackChunkName: "InductionDashboard" */ '../views/InductionControl.vue'),
    meta: {
      requiresAuth: true
    }
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (to.path == "/signup"){
    next()
  }else if(to.query.apiKey != undefined){
    const apiKey = to.query.apiKey
    next({
            path: '/signup',
            query: {
              apiKey:window.location.href
            }
          })
  }else if(requiresAuth && !auth.currentUser){
    next('/login')
  }else {
    next()
  }
  
})

export default router
